import { render, staticRenderFns } from "./supplierPriceRequestUpdateDialog.vue?vue&type=template&id=6a715dd5&"
import script from "./supplierPriceRequestUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./supplierPriceRequestUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports